export default {
  methods: {
    trackEventHome(name, subEvent) {
      let eventName = `Supplier Central Home - ${name}`;
      let params = {};
      if (subEvent) {
        params.subEvent = subEvent;
      }

      this.$hhMixpanel.trackEvent(eventName, params);
      document.title = eventName;
    },
    trackFeatureAction(featureName, actionName, actionAnchor, actionUrl) {
      this.trackEventHome(
        `${featureName} ${actionName}`,
        `${actionAnchor} - ${actionUrl}`
      );
    },
    trackFeatureSelected(featureName, actionAnchor, actionUrl) {
      this.trackEventHome(
        `${featureName} selected`,
        `${actionAnchor} - ${actionUrl}`
      );
    },
  },
};
